export const CustomerRouteConstants = {
  Examples: {}
};
